import {AppType, ChipData} from '@web-catalog/types';

import {Chip} from '@web-catalog/ui-kit/Chip';

import styles from './AppLabel.module.scss';

type Props = {
  label?: {
    name: string;
    color: 'GRAY' | 'BLUE' | 'VIOLET' | 'GREEN';
    iconUrl?: string;
  };
  appType: AppType;
};

export const AppLabel = ({label, appType}: Props) => {
  if (!label) {
    return null;
  }
  const {name, iconUrl, color} = label;
  const labelData = {
    text: name,
    colorVariant: color.toLowerCase() as ChipData['colorVariant'],
    href: '',
    type: 'labels' as const,
    iconUrl,
    capitalizeText: true,
    testId: 'app_label_test_id',
  };
  return (
    <Chip
      appType={appType}
      data={labelData}
      className={styles.label}
      isLinkComponent={false}
    />
  );
};
